import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';

import { NgSelectModule } from '@ng-select/ng-select';

import { VideoSettingsModalComponent } from './video-settings-modal.component';

@NgModule({
  declarations: [VideoSettingsModalComponent],
  imports: [CommonModule, FormsModule, NgSelectModule],
  exports: [VideoSettingsModalComponent],
})
export class VideoSettingsModalModule {}
